import { render, staticRenderFns } from "./ModalSendContract.vue?vue&type=template&id=0e88b1c3&"
import script from "./ModalSendContract.vue?vue&type=script&lang=js&"
export * from "./ModalSendContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports